import { BRAND } from "@core/brand/brand-config";
import { hasOwn } from "@core/utility/utility";
import { globalCountryDetailsDictionary } from "../global/global-country-details";

export const GLOBAL_ENUM = {
  MERGE: "merge",
  UPDATE: "update",
};

export const MONTH_ENUM = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

export const DASHBOARD_TYPE_ENUM = [
  {
    name: "Dashboard",
    icon: "https://res.cloudinary.com/drzta9shk/image/upload/v1684843322/intel/icons/dashboard_gray_favenz.svg",
    activeIcon: "https://res.cloudinary.com/drzta9shk/image/upload/v1684843322/intel/icons/dashboard_purple_z1ysoc.svg",
  },
  {
    name: "Request Center",
    icon: "https://res.cloudinary.com/drzta9shk/image/upload/v1684843322/intel/icons/request_centre_gray_s9brkb.svg",
    activeIcon: "https://res.cloudinary.com/drzta9shk/image/upload/v1684843322/intel/icons/request_centre_purple_afru6t.svg",
  },
];

export const REQUEST_TYPE = [
  {
    name: "Single",
    payload: "single",
    isChecked: false,
    id: 0,
  },
  {
    name: "Employee Level",
    payload: "bulk",
    isChecked: false,
    id: 1,
  },
  {
    name: "AI Extracted",
    payload: "ai extracted",
    isChecked: false,
    id: 2,
  },
];

export const STATUS_TYPE = [
  {
    name: "Closed",
    isChecked: false,
    id: 0,
  },
  {
    name: "In progress",
    isChecked: false,
    id: 1,
  },
];

export const countryDetails = {
  trademo_US: {
    name: "United States",
    country_code: "US",
  },
  trademo_BR: {
    name: "Brazil (Mirror)",
    country_code: "br",
  },
  trademo_UY: {
    name: "Uruguay",
    country_code: "UY",
  },
  trademo_MX: {
    name: "Mexico",
    country_code: "MX",
  },
  trademo_CH: {
    name: "Chile",
    country_code: "CL",
  },
  trademo_CO: {
    name: "Colombia",
    country_code: "CO",
  },
  trademo_AR: {
    name: "Argentina",
    country_code: "AR",
  },
  trademo_PA: {
    name: "Panama",
    country_code: "PA",
  },
  trademo_EC: {
    name: "Ecuador",
    country_code: "EC",
  },
  trademo_PR: {
    name: "Peru",
    country_code: "PE",
  },
  trademo_UK: {
    name: "United Kingdom",
    country_code: "GB",
  },
  trademo_ID: {
    name: "Indonesia (Mirror)",
    country_code: "ID",
  },
  trademo_IDNM: {
    name: "Indonesia",
    country_code: "IDNM",
  },
  trademo_PH: {
    name: "Philippines",
    country_code: "PH",
  },
  trademo_VN: {
    name: "Vietnam",
    country_code: "VN",
  },
  trademo_INMR3: {
    name: "India (Mirror 1)",
    country_code: "INMR3",
  },
  trademo_INMR: {
    name: "India (Mirror)",
    country_code: "INMR",
  },
  trademo_RU: {
    name: "Russia (Mirror)",
    country_code: "RU",
  },
  trademo_RUNM: {
    name: "Russia",
    country_code: "RUNM",
  },
  trademo_CN: {
    name: "China (Mirror)",
    country_code: "CN",
  },
  trademo_SG: {
    name: "Singapore (Mirror)",
    country_code: "SG",
  },
  trademo_MY: {
    name: "Malaysia (Mirror)",
    country_code: "MY",
  },
  trademo_TH: {
    name: "Thailand (Mirror)",
    country_code: "TH",
  },
  trademo_TR: {
    name: "Turkey (Mirror)",
    country_code: "TR",
  },
  trademo_AE: {
    name: "United Arab Emirates (Mirror)",
    country_code: "AE",
  },
  trademo_AU: {
    name: "Australia (Mirror)",
    country_code: "AU",
  },
  trademo_TW: {
    name: "Taiwan (Mirror)",
    country_code: "TW",
  },
  trademo_SA: {
    name: "Saudi Arabia (Mirror)",
    country_code: "SA",
  },
  trademo_CA: {
    name: "Canada (Mirror)",
    country_code: "CA",
  },
  trademo_DE: {
    name: "Germany (Mirror)",
    country_code: "DE",
  },
  trademo_HK: {
    name: "Hong Kong (Mirror)",
    country_code: "HK",
  },
  trademo_JP: {
    name: "Japan (Mirror)",
    country_code: "JP",
  },
  trademo_KR: {
    name: "South Korea (Mirror)",
    country_code: "KR",
  },
  trademo_MC: {
    name: "Universal Search",
    src: "https://res.cloudinary.com/drzta9shk/image/upload/v1681887388/intel/icons/alldata_icon_ednqbi.svg",
  },
  trademo_BW: {
    name: "Botswana",
    country_code: "BW",
  },
  trademo_GH: {
    name: "Ghana",
    country_code: "GH",
  },
  trademo_LS: {
    name: "Lesotho",
    country_code: "LS",
  },
  trademo_PK: {
    name: "Pakistan",
    country_code: "PK",
  },
  trademo_CI: {
    name: "Ivory Coast",
    country_code: "CI",
  },
  trademo_RW: {
    name: "Rwanda",
    country_code: "RW",
  },
  trademo_NA: {
    name: "Namibia",
    country_code: "NA",
  },
  trademo_CM: {
    name: "Cameroon",
    country_code: "CM",
  },
  trademo_BD: {
    name: "Bangladesh",
    country_code: "BD",
  },
  trademo_NG: {
    name: "Nigeria",
    country_code: "NG",
  },
  trademo_KZ: {
    name: "Kazakhstan",
    country_code: "KZ",
  },
  trademo_UZ: {
    name: "Uzbekistan",
    country_code: "UZ",
  },
  trademo_LK: {
    name: "Sri Lanka",
    country_code: "LK",
  },
  trademo_PY: {
    name: "Paraguay",
    country_code: "PY",
  },
  trademo_CR: {
    name: "Costa Rica",
    country_code: "CR",
  },
  trademo_ET: {
    name: "Ethiopia",
    country_code: "ET",
  },
  trademo_UG: {
    name: "Uganda",
    country_code: "UG",
  },
  trademo_MIDDLEEAST: {
    name: "Middle East (Mirror)",
    src: "https://res.cloudinary.com/drzta9shk/image/upload/v1759845304/intel/misc/Middle_East_vtbphh.svg",
  },
  trademo_EU: {
    name: "Europe (Mirror)",
    country_code: "EU",
  },
  trademo_USM: {
    name: "United States (Mirror)",
    country_code: "US",
  },
  trademo_MXM: {
    name: "Mexico (Maritime)",
    country_code: "MX",
  },
};

export const REQUEST_TAB_HEADER = ["Contact", "Email Alerts", "Downloads", "Due Dilligence Reports"];
export const REQUEST_SOURCE = ["contacts", "saved search", "downloads", "dueDilligenceReports"];

export const REQUEST_FREQUENCY = [
  {
    name: "Weekly",
    isChecked: false,
    id: 0,
    frequency: 7,
  },
  {
    name: "Bi-Weekly",
    isChecked: false,
    id: 1,
    frequency: 14,
  },
  {
    name: "Monthly",
    isChecked: false,
    id: 2,
    frequency: 30,
  },
];

export const REQUEST_STATUS = [
  {
    name: "in progress",
    isChecked: false,
    id: 0,
  },
  {
    name: "disabled",
    isChecked: false,
    id: 1,
  },
  {
    name: "delivered",
    isChecked: false,
    id: 2,
  },
  {
    name: "not delivered",
    isChecked: false,
    id: 3,
  },
];

export const REQUEST_DOWLOAD_DESCRIPTION = [
  {
    name: "Shipments",
    isChecked: false,
    id: 0,
    type: "shipments",
  },
  {
    name: "Unique Importer",
    isChecked: false,
    id: 1,
    type: "importers",
  },
  {
    name: "Unique Exporter",
    isChecked: false,
    id: 2,
    type: "exporters",
  },
  {
    name: "Analytics",
    isChecked: false,
    id: 3,
    type: "analytics",
  },
  {
    name: "Logistics",
    isChecked: false,
    id: 4,
    type: "logistics",
  },
  {
    name: "Company Profiles",
    isChecked: false,
    id: 5,
    type: "profiles",
  },
];

export const REQUEST_DATASOURCE = [
  {
    name: "US imports",
    isChecked: false,
    plan: "trademo_US",
  },
  {
    name: "US exports",
    isChecked: false,
    plan: "trademo_US",
  },
  {
    name: "United Kingdom imports",
    isChecked: false,
    plan: "trademo_UK",
  },
  {
    name: "United Kingdom exports",
    isChecked: false,
    plan: "trademo_UK",
  },
  {
    name: "Panama imports",
    isChecked: false,
    plan: "trademo_PA",
  },
  {
    name: "Panama exports",
    isChecked: false,
    plan: "trademo_PA",
  },
  {
    name: "Chile imports",
    isChecked: false,
    plan: "trademo_CH",
  },
  {
    name: "Chile exports",
    isChecked: false,
    plan: "trademo_CH",
  },
  {
    name: "Uruguay imports",
    isChecked: false,
    plan: "trademo_UY",
  },
  {
    name: "Uruguay exports",
    isChecked: false,
    plan: "trademo_UY",
  },
  {
    name: "Colombia imports",
    isChecked: false,
    plan: "trademo_CO",
  },
  {
    name: "Colombia exports",
    isChecked: false,
    plan: "trademo_CO",
  },
  {
    name: "Ecuador imports",
    isChecked: false,
    plan: "trademo_EC",
  },
  {
    name: "Ecuador exports",
    isChecked: false,
    plan: "trademo_EC",
  },
  {
    name: "Argentina imports",
    isChecked: false,
    plan: "trademo_AR",
  },
  {
    name: "Argentina exports",
    isChecked: false,
    plan: "trademo_AR",
  },
  {
    name: "Peru imports",
    isChecked: false,
    plan: "trademo_PR",
  },
  {
    name: "Peru exports",
    isChecked: false,
    plan: "trademo_PR",
  },
  {
    name: "Mexico imports",
    isChecked: false,
    plan: "trademo_MX",
  },
  {
    name: "Mexico exports",
    isChecked: false,
    plan: "trademo_MX",
  },
  {
    name: "Brazil imports",
    isChecked: false,
    plan: "trademo_BR",
  },
  {
    name: "Brazil exports",
    isChecked: false,
    plan: "trademo_BR",
  },
  {
    name: "Indonesia imports",
    isChecked: false,
    plan: "trademo_ID",
  },
  {
    name: "Indonesia exports",
    isChecked: false,
    plan: "trademo_ID",
  },
  {
    name: "Indonesia nm imports",
    isChecked: false,
    plan: "trademo_IDNM",
  },
  {
    name: "Indonesia nm exports",
    isChecked: false,
    plan: "trademo_IDNM",
  },
  {
    name: "Philippines imports",
    isChecked: false,
    plan: "trademo_PH",
  },
  {
    name: "Philippines exports",
    isChecked: false,
    plan: "trademo_PH",
  },
  {
    name: "Vietnam imports",
    isChecked: false,
    plan: "trademo_VN",
  },
  {
    name: "Vietnam exports",
    isChecked: false,
    plan: "trademo_VN",
  },
  {
    name: "India imports (Mirror 1)",
    isChecked: false,
    plan: "trademo_INMR3",
  },
  {
    name: "India exports (Mirror 1)",
    isChecked: false,
    plan: "trademo_INMR3",
  },
];

export const REQUEST_ALERT_TYPE = [
  { name: "Saved Search", isChecked: false, id: 0 },
  { name: "Company", isChecked: false, id: 0 },
];

export const REQUEST_STATUS_TYPE_MIRA = [
  { name: "Pending", isChecked: false, id: 0 },
  { name: "Delivered", isChecked: false, id: 1 },
];

export const COMPANY_PROFILE_LIST = ["deals in product HS codes", "business with Consignees/ Shippers", "expansions to Markets/ Countries", "shipments received or sent from Ports"];

export const TAB_DATA_SOURCE = {
  imports: "imports",
  exports: "exports",
};

export const unifiedIsoCountries = {
  ZZ: "All Countries",
  UK: "United Kindom",
  EU: "European Union",
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  AX: "Åland Islands",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Cabo Verde",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CD: "Congo (the Democratic Republic of the)",
  CG: "Congo",
  CK: "Cook Islands",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czechia",
  CI: "Côte d'Ivoire",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  SZ: "Eswatini",
  ET: "Ethiopia",
  FK: "Falkland Islands",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran (Islamic Republic of)",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea (the Democratic People's Republic of)",
  KR: "Korea (the Republic of)",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia (Federated States of)",
  MD: "Moldova (the Republic of)",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: "North Macedonia",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestine, State of",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Romania",
  RU: "Russia",
  RW: "Rwanda",
  RE: "Réunion",
  BL: "Saint Barthélemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Dutch part)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan (Province of China)",
  TJ: "Tajikistan",
  TZ: "Tanzania, the United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  UM: "United States Minor Outlying Islands",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela (Bolivarian Republic of)",
  VN: "Vietnam",
  VG: "Virgin Islands (British)",
  VI: "Virgin Islands (U.S.)",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Republic of Kosovo",
  XI: "Northern Ireland (United Kingdom)",
  XC: "Ceuta",
  XL: "Melilla",
};

//The below mapping is to show DATASET type on UI for different country
export const DATASET_TYPE_MAPPING = {
  ru_import: " (Mirror)",
  ru_export: " (Mirror)",
  th_import: " (Mirror)",
  th_export: " (Mirror)",
  cn_import: " (Mirror)",
  cn_export: " (Mirror)",
  ca_import: " (Mirror)",
  ca_export: " (Mirror)",
  jp_import: " (Mirror)",
  jp_export: " (Mirror)",
  de_import: " (Mirror)",
  de_export: " (Mirror)",
  hk_import: " (Mirror)",
  hk_export: " (Mirror)",
  my_import: " (Mirror)",
  my_export: " (Mirror)",
  sa_import: " (Mirror)",
  sa_export: " (Mirror)",
  kr_import: " (Mirror)",
  kr_export: " (Mirror)",
  tw_import: " (Mirror)",
  tw_export: " (Mirror)",
  ae_import: " (Mirror)",
  ae_export: " (Mirror)",
  au_import: " (Mirror)",
  au_export: " (Mirror)",
  sg_import: " (Mirror)",
  sg_export: " (Mirror)",
  tr_import: " (Mirror)",
  tr_export: " (Mirror)",
  br_import: " (Mirror)",
  br_export: " (Mirror)",
  id_import: " (Mirror)",
  id_export: " (Mirror)",
  inmr3_import: " (Mirror 1)",
  inmr3_export: " (Mirror 1)",
  inmr_import: " (Mirror)",
  inmr_export: " (Mirror)",
  usm_import: " (Non-Maritime)",
  usm_export: " (Non-Maritime)",
  us_import: " (Maritime)",
  us_export: " (Maritime)",
  mxm_import: " (Maritime)",
  mxm_export: " (Maritime)",
  mxm: " (Maritime)",
  us: " (Maritime)",
  usm: " (Non-Maritime)",
  id: " (Mirror)",
  ru: " (Mirror)",
  inmr: " (Mirror)",
  th: " (Mirror)",
  cn: " (Mirror)",
  my: " (Mirror)",
  ae: " (Mirror)",
  au: " (Mirror)",
  sg: " (Mirror)",
  tr: " (Mirror)",
  br: " (Mirror)",
};

const DATASET_MIRROR_SORT_OVERRIDES = {
  usm_import: 1,
  usm_export: 1,
};

let datasetNameByDataSource = null;

export const getDatasetNameByDataSource = (dataSource = "") => {
  if (!datasetNameByDataSource) {
    datasetNameByDataSource = {};
    for (const key in globalCountryDetailsDictionary) {
      const { dataSource: datasetSource, countryName } = globalCountryDetailsDictionary[key];
      if (datasetSource && countryName) datasetNameByDataSource[datasetSource.toLowerCase()] = countryName;
    }
  }
  return datasetNameByDataSource[dataSource?.trim?.().toLowerCase()] ?? null;
};

export const SHIPMENT_DATASET_DISPLAY_NAME_OVERRIDES = {
  "us mirror": "US",
  "mexico maritime": "Mexico",
  "russia nm": "Russia",
  "indonesia nm": "Indonesia",
  "india mirror": "India",
  world: "Universal Search",
  "india mirror 3": "India",
  multicountry: "Universal Search",
  "global data": "Universal Search",
};

// Source Atlas ships a single whole-world dataset, so nothing that identifies
// which dataset a record belongs to - name, flag, globe - carries information
// there. Every such surface hides it together; showing one without the others
// leaves an icon floating beside a blank label.
export const HIDE_DATASET_IDENTITY = BRAND.key === "source_atlas";

export const HIDE_PORT_PROFILE_UPSELL = BRAND.key === "source_atlas";

export const SHOW_GLOBAL_DATA_HS_CODE_LINK = BRAND.key === "source_atlas";

export const getShipmentDatasetDisplayName = (country = "", tradeDirection = "") => {
  // The company profile distribution panel is always one row for Source Atlas,
  // and that row is simply the company's whole shipment count.
  if (HIDE_DATASET_IDENTITY) return "Total Number of Shipments";

  const normalizedCountry = country.toLowerCase();

  return `${SHIPMENT_DATASET_DISPLAY_NAME_OVERRIDES[normalizedCountry] ?? country} ${tradeDirection}`.trim();
};

// Universal-search datasets (world / multicountry / global data) should not render a trade direction suffix.
export const isUniversalSearchDataset = (country = "", countryCode = "") => countryCode?.toLowerCase() === "world" || SHIPMENT_DATASET_DISPLAY_NAME_OVERRIDES[country?.toLowerCase()] === "Universal Search";

export const getDatasetDisplayName = (country = "", fallback = country) => {
  if (HIDE_DATASET_IDENTITY) return "";
  return SHIPMENT_DATASET_DISPLAY_NAME_OVERRIDES[country?.toLowerCase()] || fallback || "";
};

export const getDatasetMirrorSortGroup = (countryCode = "", tradeDirection = "") => {
  const normalizedTradeDirection = tradeDirection?.toLowerCase()?.endsWith("s") ? tradeDirection?.toLowerCase()?.slice(0, -1) : tradeDirection?.toLowerCase();
  const datasetKey = `${countryCode?.toLowerCase()}_${normalizedTradeDirection}`;

  if (hasOwn(DATASET_MIRROR_SORT_OVERRIDES, datasetKey)) {
    return DATASET_MIRROR_SORT_OVERRIDES[datasetKey];
  }

  const datasetLabel = DATASET_TYPE_MAPPING[datasetKey] ?? "";

  return datasetLabel.includes("(Mirror)") || datasetLabel.includes("(Mirror 1)") ? 1 : 0;
};

export const CountryCodeOneToOneMap = {
  usm: "us",
  mxm: "mx",
  runm: "ru",
  idnm: "id",
  inmr: "in",
  inmr3: "in",
};
